import React from 'react';
import { Pane, Card, Heading, Table, Text } from 'evergreen-ui';

const RevenueByRegionTable = ({ data, formatCurrencyWithSymbol, currencySymbol }) => {
    if (!data || data.length === 0) {
        return (
            <Card flex={1} padding={16} background="tint1" elevation={1}>
                <Heading size={500} marginBottom={16}>
                    Revenue by Region
                </Heading>
                <Pane display="flex" alignItems="center" justifyContent="center" height={100}>
                    <Text>No regional sales data available.</Text>
                </Pane>
            </Card>
        );
    }

    const totalRevenue = data.reduce((sum, item) => sum + item.totalRevenue, 0);

    return (
        <Card flex={1} padding={16} background="tint1" elevation={1}>
            <Heading size={500} marginBottom={16}>
                Revenue by Region
            </Heading>
            <Table>
                <Table.Head>
                    <Table.TextHeaderCell>Region</Table.TextHeaderCell>
                    <Table.TextHeaderCell textAlign="right">Revenue</Table.TextHeaderCell>
                </Table.Head>
                <Table.Body>
                    {data.map((item, index) => (
                        <Table.Row key={index}>
                            <Table.TextCell>{item.region?.name || 'Rest of World'}</Table.TextCell>
                            <Table.TextCell textAlign="right">
                                {formatCurrencyWithSymbol(item.totalRevenue)}
                            </Table.TextCell>
                        </Table.Row>
                    ))}
                    <Table.Row>
                        <Table.TextHeaderCell>Total</Table.TextHeaderCell>
                        <Table.TextHeaderCell textAlign="right">
                            {formatCurrencyWithSymbol(totalRevenue)}
                        </Table.TextHeaderCell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </Card>
    );
};

export default RevenueByRegionTable;
